import styled from '@emotion/styled'

const withStyle = (Component) =>
  styled(Component)(
    (props) => `
        .ant-radio-button-wrapper {
          color: ${props.theme.radioButtonGroupColor};
          background-color: ${props.theme.radioButtonGroupBg};
          border: 1px solid;
          border-color: ${props.theme.radioButtonGroupBorderColor};
          text-transform: capitalize;
          &:hover {
            color: ${props.theme.radioButtonGroupHoverColor};
            background-color: ${props.theme.radioButtonGroupHoverBg};
            border-color: ${props.theme.radioButtonGroupHoverBorderColor};
          }
          &:focus {
            color: ${props.theme.radioButtonGroupFocusColor};
            background-color: ${props.theme.radioButtonGroupFocusBg};
            border-color: ${props.theme.radioButtonGroupFocusBorderColor};
          }
          &.ant-radio-button-wrapper-disabled {
            color: ${props.theme.radioButtonGroupDisabledColor};
            background-color: ${props.theme.radioButtonGroupDisabledBg};
            border-color: ${props.theme.radioButtonGroupDisabledBorderColor};
          }
          svg {
            margin-bottom: -4px;
          }
        }
        .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
          color: ${props.theme.radioButtonGroupSelectedColor};
          background: ${props.theme.radioButtonGroupSelectedBg};
          background-color: ${props.theme.radioButtonGroupSelectedBg};
          border-color: ${props.theme.radioButtonGroupSelectedBorderColor};
          box-shadow: none;
          svg path {
            fill: ${props.theme.radioButtonGroupSelectedColor};
          }
          &:hover {
            color: ${props.theme.radioButtonGroupSelectedColor};
            background: ${props.theme.radioButtonGroupSelectedBg};
            background-color: ${props.theme.radioButtonGroupSelectedBg};
            border-color: ${props.theme.radioButtonGroupSelectedBg};
          }
          &:before {
            background-color: ${props.theme.radioButtonGroupHoverBg};
          }
        }
      `
  )

export default withStyle
